import React, { useState } from 'react';
import './Home.css'; 
import { Link } from 'react-router-dom';
import Navbar from '../Components/Navbar';
import Chatbot from './Pages/Chatbot';


function Home() {
  const [file, setFile] = useState(null);
  const [url, setUrl] = useState('');

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleUrlChange = (event) => {
    setUrl(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Handle the upload logic here
    console.log('File:', file);
    console.log('URL:', url);
  };

  return (
    <div className="app-home">
      <header>
        <Navbar />
      </header>
      <main className='mainhome'>
        <h1>Upload your contract</h1>
        <p className='caution'>Make sure that you have the right contract uploaded</p>
        <form onSubmit={handleSubmit}>
          <div className="upload-section-home">
            <label htmlFor="file-upload-home" className="file-upload-label-home">
              <div className="upload-box-home">
                <span className='upload-home'>Upload your contract</span>
                <span className='drag-home'>or drag and drop <br></br></span>
                <span className='file-size-home'>SOL or TXT up to 5MB</span>
              </div>
              <input
                id="file-upload-home"
                type="file"
                accept=".sol, .txt"
                onChange={handleFileChange}
                style={{ display: 'none' }}
                
              />
            </label>
            <div class="divider">
          <hr class="dividerline"></hr>
          <span class="dividertext">OR</span>
          <hr class="dividerline"></hr>
        </div>
            <input
              type="text"
              placeholder="Paste contract URL"
              value={url}
              onChange={handleUrlChange}
              className="url-input-home"
            />
          </div>
          <Link to="/Upload"><button type="submit" className="upload-button-home">Upload</button></Link>
        </form>
      </main>
      <Chatbot />
    </div>
  );
}

export default Home;
